import { HereMapInterface } from "common/utils/Map";
import { useMapContext } from "../context";
import {
  useApplicationOperations,
  useZoomSelector,
} from "entities/application";
import { useEffect, useRef } from "react";

export const useMapZoomObserver = () => {
  const { map } = useMapContext();
  const { setZoom } = useApplicationOperations();
  const savedZoomValue = useZoomSelector();

  const intervalIdRef = useRef<null | number>(null);
  const savedZoomRef = useRef<number>(savedZoomValue);

  useEffect(() => {
    savedZoomRef.current = savedZoomValue;
  }, [savedZoomValue]);

  useEffect(() => {
    if (map && intervalIdRef.current === null) {
      //@ts-ignore
      intervalIdRef.current = setInterval(() => {
        const currentZoom = Math.floor((map as HereMapInterface).getZoom());
        if (currentZoom !== savedZoomRef.current) {
          setZoom(currentZoom);
        }
      }, 1000);
    }
    //@ts-ignore
    return () => clearInterval(intervalIdRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);
};
